
import { defineComponent, computed } from "vue";

// Các luồng khai NGAY TRONG component (không tách file .ts riêng: thêm file .ts mới giữa phiên dev
// làm ts-loader báo TS2307 tới khi restart dev server) — đổi tên/đường dẫn bước sửa đúng 1 chỗ.
const FLOWS = {
  lienthong: {
    title: "Luồng liên thông",
    steps: [
      { label: "Xét tuyển liên thông", to: "/xettuyenlienthong" },
      { label: "Kết quả tuyển sinh", to: "/ketquatuyensinhlienthong" },
      { label: "Danh sách trúng tuyển", to: "/danhsachtrungtuyen" },
    ],
  },
};

export default defineComponent({
  name: "flow-nav",
  props: {
    // Tên luồng dựng sẵn (xem FLOWS)
    flow: { type: String, default: "" },
    // Hoặc truyền thẳng danh sách bước: [{ label, to }]
    steps: { type: Array as () => Array<{ label: string; to: string }>, default: () => [] },
    // Vị trí (0-based) của trang hiện tại
    current: { type: Number, default: 0 },
    title: { type: String, default: "" },
  },
  setup(props) {
    const preset = computed(() => FLOWS[props.flow] || null);
    const items = computed(() => (props.steps.length ? props.steps : (preset.value ? preset.value.steps : [])));
    const flowTitle = computed(() => props.title || (preset.value ? preset.value.title : "Luồng xử lý"));
    return { items, flowTitle };
  },
});
